import { lazy } from 'react';

import { Navigate } from 'react-router-dom';
import HomePage from 'pages/HomePage';
import { ROUTES } from 'constants/router';
import Loadable from 'components/loadable/Loadable';
import BlankLayout from 'layouts/BlankLayout';
import LoginPage from 'pages/LoginPage';
import ProfilePage from 'pages/ProfilePage';
import EditProfilePage from 'pages/EditProfilePage';
import HelpPage from 'pages/HelpPage';
import TermConditionPage from 'pages/TermConditionPage';
import PrivacyPage from 'pages/PrivacyPage';
import ContactPage from 'pages/ContactPage';

import NotifyPage from 'pages/NotifyPage';
import NotifyDetailPage from 'pages/NotifyDetailPage';
import DetailRoomPage from 'pages/DetailRoomPage';
import PartnerPage from 'pages/PartnerPage';
import BuildingRoomPage from 'pages/BuildingRoomPage';

/* ***Layouts**** */
const MainLayout = Loadable(lazy(() => import('layouts/MainLayout')));

const Router = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '/', element: <Navigate to={ROUTES.HOME} /> },
      { path: ROUTES.HOME, exact: true, element: <HomePage /> },
    ],
  },

  {
    path: '/',
    element: <MainLayout hideHeader />,
    children: [{ path: ROUTES.PROFILE, exact: true, element: <ProfilePage /> }],
  },

  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: ROUTES.LOGIN, element: <LoginPage /> },

      { path: ROUTES.NOTIFY, element: <NotifyPage /> },
      { path: ROUTES.DETAIL_NOTIFY, element: <NotifyDetailPage /> },

      { path: ROUTES.EDIT_PROFILE, element: <EditProfilePage /> },
      { path: ROUTES.HELP_PROFILE, element: <HelpPage /> },
      { path: ROUTES.TERM_PROFILE, element: <TermConditionPage /> },
      { path: ROUTES.PRIVACY_PROFILE, element: <PrivacyPage /> },
      { path: ROUTES.CONTACT_PROFILE, element: <ContactPage /> },

      { path: ROUTES.ROOM_DETAIL, element: <DetailRoomPage /> },

      { path: ROUTES.PARTNER, element: <PartnerPage /> },
      { path: ROUTES.PARTNER_BUILDING, element: <BuildingRoomPage /> },
    ],
  },
];

export default Router;
